/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {service as TaxLotService} from "../../../Services/TaxLotService";
import {ServiceDrivenAutoCompleteFieldEditor} from "./ServiceDrivenAutoCompleteFieldEditor";

export const TaxLotFieldEditor = ServiceDrivenAutoCompleteFieldEditor(TaxLotService);

